import React, { Component } from 'react';
import { reduxForm, Field } from 'redux-form';
import { withRouter } from 'react-router';
import { Form, Grid, Button } from 'semantic-ui-react';

import { PROVISION_2_BASE_RATES_SETUP_FORM_NAME } from 'Common/FormEnum';
import { SelectField, ToggleField } from 'Common/SemanticWrapper';
import { Provision2BaseRatesEnum as Fields } from 'Common/FieldEnum';
import { SiteComponent } from 'Common/SiteComponent';
import { AlternateProvisionTypeEnum } from 'Common/Constants/Enumeration/AlternateProvisionTypeEnum';

import { BaseRatesGrid } from '../component/BaseRatesGrid';
import { TitledCard } from 'Components/';
import { months } from '../helpers/constants';

import 'Styles/pages/provision2baseratessetup/provision2style.less';

class Provision2BaseRatesFormContainer extends Component {
  alternateProvisionTypes = [
    AlternateProvisionTypeEnum.Prov2_Non_Base_Breakfast_Only,
    AlternateProvisionTypeEnum.Provision2_Non_Base,
  ];

  renderUseAnotherFiscalYearCard = () => {
    const {
      otherFiscalYear,
      handleResetRatesClick,
      handleSetRatesClick,
      siteId,
      updateOtherFiscalYear,
      showUseAnotherFiscalYear,
      otherFiscalYears,
    } = this.props;

    if (showUseAnotherFiscalYear) {
      return (
        <TitledCard title={'Use Rates From Another Fiscal Year'}>
          <Grid>
            <Grid.Row>
              <div className={'alt-fiscal-year'}>
                <Field
                  name={Fields.OtherFiscalYear}
                  label={'Fiscal Year'}
                  component={SelectField}
                  options={otherFiscalYears}
                  disabled={siteId === null}
                  onChange={(e, otherFiscalYear) => {
                    updateOtherFiscalYear(otherFiscalYear);
                  }}
                />
              </div>

              <div className={'set-rates-button'}>
                <Button
                  onClick={handleSetRatesClick}
                  disabled={siteId === null && otherFiscalYear === null}
                >
                  Populate Table
                </Button>
              </div>

              <div className={'reset-rates-button'}>
                <Button
                  onClick={handleResetRatesClick}
                  disabled={siteId === null && otherFiscalYear === null}
                >
                  Reset Table
                </Button>
              </div>
            </Grid.Row>
          </Grid>
        </TitledCard>
      );
    }
  };

  render() {
    const {
      siteId,
      gridDataLunch,
      gridDataBreakfast,
      dispatch,
      change,
      updateBreakfastGridData,
      updateLunchGridData,
      handleSiteChange,
      fiscalYear,
      fiscalYears,
      handleFiscalYearChange,
      updateTotalField,
      setToggle,
      loading,
      alternateProvisionTypeId,
    } = this.props;

    const hideLunchRates =
      alternateProvisionTypeId ===
      AlternateProvisionTypeEnum.Prov2_Non_Base_Breakfast_Only;

    return (
      <Form name="Provision2BaseRatesForm">
        <Grid>
          <Grid.Column>
            <Grid.Row>
              <TitledCard title={'Base Rates Setup'}>
                <Grid>
                  <Grid.Row>
                    <Grid.Column width={5}>
                      <SiteComponent
                        onChange={handleSiteChange}
                        isAllRequired={false}
                        alternateProvisionTypes={this.alternateProvisionTypes}
                        isPrimary={true}
                      />
                    </Grid.Column>
                    <Grid.Column width={3}>
                      <Field
                        name={Fields.FiscalYear}
                        label={'Fiscal Year'}
                        component={SelectField}
                        options={fiscalYears}
                        disabled={siteId === null}
                        onChange={handleFiscalYearChange}
                      />
                    </Grid.Column>
                  </Grid.Row>
                  <Grid.Row>
                    <Grid.Column width={6}>
                      <div className={'togglePrevious'}>
                        <Field
                          component={ToggleField}
                          name={Fields.ShowUseAnotherYearToggle}
                          label={'Use Rates From Another Fiscal Year'}
                          onChange={(e, toggled) => {
                            setToggle(toggled);
                          }}
                        />
                      </div>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </TitledCard>
            </Grid.Row>
            <Grid.Row>{this.renderUseAnotherFiscalYearCard()}</Grid.Row>
            <Grid.Row>
              <TitledCard title={'Breakfast Rates'}>
                <BaseRatesGrid
                  gridData={gridDataBreakfast}
                  isBreakfast={true}
                  change={change}
                  dispatch={dispatch}
                  siteId={siteId}
                  fiscalYear={fiscalYear}
                  updateGridData={updateBreakfastGridData}
                  updateTotalField={updateTotalField}
                  loading={loading}
                />
              </TitledCard>
            </Grid.Row>
            {!hideLunchRates && (
              <Grid.Row>
                <TitledCard title={'Lunch Rates'}>
                  <BaseRatesGrid
                    gridData={gridDataLunch}
                    isBreakfast={false}
                    change={change}
                    dispatch={dispatch}
                    siteId={siteId}
                    fiscalYear={fiscalYear}
                    updateGridData={updateLunchGridData}
                    updateTotalField={updateTotalField}
                    loading={loading}
                  />
                </TitledCard>
              </Grid.Row>
            )}
          </Grid.Column>
        </Grid>
      </Form>
    );
  }
}

const validate = (values) => {
  const errors = {};
  months.forEach((month) => {
    if (
      parseFloat(values[`${month}TotalBreakfast`]) !== 0 &&
      parseFloat(values[`${month}TotalBreakfast`]) !== 100
    ) {
      errors[`${month}TotalBreakfast`] = 'totals must equal 0 or 100';
      errors[`${month}FreeBreakfast`] = 'totals must equal 0 or 100';
      errors[`${month}ReducedBreakfast`] = 'totals must equal 0 or 100';
      errors[`${month}PaidBreakfast`] = 'totals must equal 0 or 100';
    }
    if (
      parseFloat(values[`${month}TotalLunch`]) !== 0 &&
      parseFloat(values[`${month}TotalLunch`]) !== 100
    ) {
      errors[`${month}TotalLunch`] = 'totals must equal 0 or 100';
      errors[`${month}FreeLunch`] = 'totals must equal 0 or 100';
      errors[`${month}ReducedLunch`] = 'totals must equal 0 or 100';
      errors[`${month}PaidLunch`] = 'totals must equal 0 or 100';
    }
  });

  return errors;
};

export const Provision2BaseRatesForm = reduxForm({
  form: PROVISION_2_BASE_RATES_SETUP_FORM_NAME,
  touchOnBlur: false,
  destroyOnUnmount: false,
  validate,
})(withRouter(Provision2BaseRatesFormContainer));



// WEBPACK FOOTER //
// ./src/pages/provision2baseratessetup/component/Provision2BaseRatesSetupForm.js